import utils from '../libs/utils';
import axios from './axios';

const baseUrl = 'v1/erp-base-web';
// const baseUrl = '';
export default {
  axios,
  // 查询总部列表数据
  SupplierGeneralList(params) { // search
    return axios.get(`${baseUrl}/supplier/general/list?${utils.exchangeParams(params)}`);
  },
  // 供应商列表
  SupplierStoreOuterList(params) {
    return axios.post(`${baseUrl}/supplier/outer/list`, utils.exchangeParams(params));
  },
  SupplierStoreList(params) { // search
    return axios.get(`${baseUrl}/supplier/store/list?${utils.exchangeParams(params)}`);
  },
  SupplierGeneralInfos(params) {
    // console.log(params);
    return axios.get(`${baseUrl}/supplier/general/detail?${utils.exchangeParams(params)}`);
  },
  SupplierGeneralSave(params) {
    // console.log(params);
    return axios.post(`${baseUrl}/supplier/general/add`, utils.exchangeParams(params));
  },
  SupplierGeneralUpdate(params) {
    // console.log(params);
    return axios.post(`${baseUrl}/supplier/general/edit`, utils.exchangeParams(params));
  },

  // 禁用总部供应商基础资料
  supplierGeneralDisable(params) {
    return axios.post(`${baseUrl}/supplier/general/disbale`, utils.exchangeParams(params));
  },

  // 启用总部供应商基础资料
  supplierGeneralEnable(params) {
    return axios.post(`${baseUrl}/supplier/general/enable`, utils.exchangeParams(params));
  },

  // 禁用门店供应商基础资料
  supplierStoreDisable(params) {
    return axios.post(`${baseUrl}/supplier/store/disbale`, utils.exchangeParams(params));
  },
  SupplierStoreInfos(params) {
    // console.log(params);
    return axios.get(`${baseUrl}/supplier/store/detail?${utils.exchangeParams(params)}`);
  },
  SupplierStoreSave(params) {
    // console.log(params);
    return axios.post(`${baseUrl}/supplier/store/add`, utils.exchangeParams(params));
  },
  SupplierStoreUpdate(params) {
    // console.log(params);
    return axios.post(`${baseUrl}/supplier/store/edit`, utils.exchangeParams(params));
  },
  SupplierStoreSubmit(params) {
    // console.log(params);
    return axios.post(`${baseUrl}/supplier/store/submit`, utils.exchangeParams(params));
  },
  // 启用门店供应商基础资料
  supplierStoreEnable(params) {
    return axios.post(`${baseUrl}/supplier/store/enable`, utils.exchangeParams(params));
  },
  supplierScope() {
    return axios.get(`${baseUrl}/supplier/business/scope`);
  },
  supplierSocialCodeCheck(params) {
    return axios.get(`${baseUrl}/supplier/store/detail/bySocialCode?${utils.exchangeParams(params)}`);
  },
  supplierGeneralNameCheck(params) {
    return axios.get(`${baseUrl}/supplier/general/list/byFuzzyName?${utils.exchangeParams(params)}`);
  },
  FirstSupplierCheck(params) {
    return axios.get(`${baseUrl}/supplier/store/contact?${utils.exchangeParams(params)}`);
  },
  supplierInfo(params) {
    return axios.get(`${baseUrl}/supplier/history/show/last/recoder?${utils.exchangeParams(params)}`);
  },
  getRecord(params) {
    return axios.get(`${baseUrl}/supplier/history/list?${utils.exchangeParams(params)}`);
  },
  supplierUpdateInfo(params) {
    return axios.get(`${baseUrl}/supplier/compare/diffs?${utils.exchangeParams(params)}`);
  },
  supplierUpdate(params) {
    return axios.get(`${baseUrl}/supplier/store/reference?${utils.exchangeParams(params)}`);
  },
  mnemonicCode(params) {
    return axios.get(`${baseUrl}/supplier/general/mnemonicCode?${utils.exchangeParams(params)}`);
  },
  goodsLabelList(params) {
    return axios.get(`${baseUrl}/goods/label/list?${utils.exchangeParams(params)}`);
  },
  getSupplierStorePrintInfo(params) {
    return axios.get(`${baseUrl}/supplier/store/print?${utils.exchangeParams(params)}`);
  },
  downloadGeneral(params) {
    return axios.post(`${baseUrl}/supplier/general/download`, utils.exchangeParams(params), {
      responseType: 'blob',
    });
  },
  downloadStore(params) {
    return axios.post(`${baseUrl}/supplier/store/download`, utils.exchangeParams(params), {
      responseType: 'blob',
    });
  },
  // 删除首营供应商
  SupplierDelete(params) {
    return axios.post(`${baseUrl}/supplier/store/delete`, utils.exchangeParams(params));
  },
};
